import { makeStyles } from '@fluentui/react-components';
import { Color } from 'libs/theme/src/lib/colors';

export const extensionRequestDialogStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '6px',
    boxSizing: 'border-box',
    width: '25rem',
  },
  modalHeader: {
    display: 'flex',
    padding: '0.75rem',
    borderTopRightRadius: '5px',
    borderTopLeftRadius: '5px',
    backgroundColor: Color.drawer_header_color,
    alignItems: 'center',
    fontSize: '1rem',
    fontWeight: 700,
    justifyContent: 'space-between',
    width: '24.9rem',
  },
  modalBody: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'start',
    padding: '1.5rem',
    gap: '1rem',
  },
  modalFooter: {
    gap: '1rem',
    padding: '0.75rem',
    width: '24.8rem',
    backgroundColor: Color.drawer_header_color,
    boxShadow: 'inset 0px 1px 0px var(--gray-200)',
    justifyContent: 'center',
  },
  fieldsWidth: {
    width: '100%',
  },
  modalWidth: {
    width: '25rem',
  },
  date: {
    width: '100%',
  },
  currentDueDateInfo: {
    width: '100%',
    padding: '0.5rem',
    margin: '0 0 1rem 0',
    backgroundColor: 'var(--colorNeutralBackground2)',
    borderRadius: '4px',
  },
  confirmationSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
    margin: '1rem 0 2rem 0',
    textAlign: 'center',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '4rem',
    height: '4rem',
    backgroundColor: '#FFE6E6',
    borderRadius: '50%',
  },
  deleteIcon: {
    fontSize: '2rem',
    color: '#E74856',
  },
  confirmationMessage: {
    fontSize: '1rem',
    fontWeight: 400,
    color: 'var(--colorNeutralForeground1)',
    lineHeight: '1.4',
  },
});
